import {
	connect
} from 'react-redux'
import LabelComponent from '../components/LabelComponent.jsx';
import {
	changeLabelOrderId,
	findAllOrderIds,
	changeLabelEventKey,
	findNoLabelGeneratedCount,
	findSerialNoData,
	findSpecialNoteList,
	exportSpecialNoteList,
	clearSpecialNoteDownloadUrl,
	clearSerialNoDownloadUrl,
	findDeletedLogIds
} from '../actions';

const mapStateToProps = (state) => ({
	orderId: state.getIn(['labelReducer', 'orderId']),
	allOrderIds: state.getIn(['labelReducer', 'allOrderIds']),
	eventKey: state.getIn(['labelReducer', 'eventKey']),
	roles: state.getIn(['authReducer', 'roles']),
	specialNoteDownloadUrl: state.getIn(['labelReducer', 'specialNoteDownloadUrl'])
})

const mapDispatchToProps = (dispatch) => ({
	changeOrderId: (payload) => {
		dispatch(changeLabelOrderId(payload));
	},
	changeEventKey: (key) => {
		dispatch(changeLabelEventKey(key));
	},
	findAllOrderIds: () => {
		dispatch(findAllOrderIds());
	},
	findNoLabelGeneratedCount: (payload) => {
		dispatch(findNoLabelGeneratedCount(payload));
	},
	findSerialNoData: (payload) => {
		dispatch(findSerialNoData(payload));
	},
	findSpecialNoteList: (payload) => {
		dispatch(findSpecialNoteList(payload, { activePage: 1, itemPerPage: 10 }));
	},
	exportSpecialNoteList: (payload) => {
		dispatch(exportSpecialNoteList(payload));
	},
	clearSpecialNoteDownloadUrl: () => {
		dispatch(clearSpecialNoteDownloadUrl());
	},
	clearSerialNoDownloadUrl: () => {
		dispatch(clearSerialNoDownloadUrl());
	},
	findDeletedLogIds: (payload) => {
		dispatch(findDeletedLogIds(payload));
	}
})

const LabelContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(LabelComponent)

export default LabelContainer;


// WEBPACK FOOTER //
// ./src/containers/LabelContainer.jsx